// extracted by mini-css-extract-plugin
export default {"section":"_e1cdfe0a","header":"_e9a3cf3c"};